import { useEffect } from 'react'

import { EVENT_NAME_PAGE_SHOW } from '../constants/event'

/**
 * This hook needs for call callback function on `pageshow` event
 * Can be useful for reload list page on press `back` button in browser
 *
 * @param callback
 */
export function usePageShowReload(callback) {
  useEffect(() => {
    function handlePageShow(event) {
      if (event.persisted) {
        callback()
      }
    }

    window.addEventListener(EVENT_NAME_PAGE_SHOW, handlePageShow)

    return () => {
      window.removeEventListener(EVENT_NAME_PAGE_SHOW, handlePageShow)
    }
  }, [callback])
}
